import {
  BarChart3, Building2, ClipboardList, CreditCard, LayoutDashboard, Package2, ScrollText, Settings, Wallet, type LucideIcon,
} from 'lucide-react';
import type { PlatformPermission } from '@/lib/permissions';

export interface PlatformNavItem { label: string; to: string; icon: LucideIcon; permission: PlatformPermission; end?: boolean }
export interface PlatformNavSection { title: string; items: PlatformNavItem[] }

/** Single source of truth for the Super Admin sidebar AND route guards (app/platformRoutes.tsx). */
export const PLATFORM_NAV: PlatformNavSection[] = [
  { title: 'Overview', items: [{ label: 'Dashboard', to: '/super-admin', icon: LayoutDashboard, permission: 'platform.dashboard.view', end: true }] },
  { title: 'Tenants', items: [{ label: 'All tenants', to: '/super-admin/tenants', icon: Building2, permission: 'platform.tenants.read' }] },
  {
    title: 'Monetization', items: [
      { label: 'Plans', to: '/super-admin/plans', icon: Package2, permission: 'platform.plans.manage' },
      { label: 'Subscriptions', to: '/super-admin/subscriptions', icon: CreditCard, permission: 'platform.billing.manage' },
      { label: 'Payments', to: '/super-admin/payments', icon: Wallet, permission: 'platform.billing.manage' },
    ],
  },
  {
    title: 'Platform', items: [
      { label: 'Feature registry', to: '/super-admin/features', icon: ClipboardList, permission: 'platform.features.manage' },
      { label: 'Analytics', to: '/super-admin/analytics', icon: BarChart3, permission: 'platform.analytics.view' },
    ],
  },
  {
    title: 'System', items: [
      { label: 'Audit logs', to: '/super-admin/audit-log', icon: ScrollText, permission: 'platform.audit.view' },
      { label: 'Settings', to: '/super-admin/settings', icon: Settings, permission: 'platform.settings.manage' },
    ],
  },
];
